import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
 
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/core/styles';
import { Box,Card  ,CardContent ,IconButton,Tooltip,
    //Radio ,RadioGroup,FormLabel,FormControlLabel,Typography,TextField,SvgIcon,
    FormControl,InputLabel,Select as MaterialSelect, 
    Typography} from '@material-ui/core'
 
const useStyles = makeStyles((theme)=>({
    root: {
      minWidth: 275,
    },     
   
  }));

const Tablero = () => {
    let history = useHistory();
    const classes = useStyles();
    const {usuario,guardarUsuario}=React.useContext(AuthContext);
    const {guardarGenerales}=React.useContext(GeneralesContext);  
    const [opcion, setOpcion] =useState(1)
    const [ruta, setRuta] =useState("")

    React.useEffect(()=>{                     
		const veriSesion =  () => 
        {            
            const usu= localStorage.getItem('UsuarioNom');
            const nvl= localStorage.getItem('Tipo');
             
            if(usu==null)
            {                                
                guardarUsuario([])						
                guardarGenerales([])     
                localStorage.clear();           
                history.push("/")	
            }
            else
            {
               
                if (usuario.length==0) 
                {
                    guardarUsuario({Nombre:usu,nivel:nvl});                                      
                }
                guardarGenerales({Titulo:'Tablero'})                     
            }
        }
       
	    veriSesion();	
        		
},[]);
    
 useEffect(()=>{
    if (opcion===1) {
       setRuta("agenda") 
    }
    else{
        if (opcion===2) {
            setRuta("paros") 
        }
        else{
            if (opcion===3) {
                setRuta("ordenes-agenda") 
            }
        }
    }
 },[opcion])

const cardOpcion=()=>{
    const estiloSelect= opcion===1 ? {backgroundColor:"#51ad32", }:{}
    const estiloSelect2=opcion===2 ? {backgroundColor:"#51ad32", }:{}
    const estiloSelect3=opcion===3 ? {backgroundColor:"#51ad32", }:{}
    return(
    <Box display={"flex"} flexDirection={"row"} mb={1} justifyContent={"center"} >
        <Typography  title={'Tablero de Ordenes de Trabajo.'}>
            <Card onClick={()=>setOpcion(1)} style={{marginRight:"1rem"}} >
                <CardContent  style={{padding:0, paddingTop:".5rem", paddingBottom:".5rem", paddingRight:".5rem",  paddingLeft:".5rem",   
                    ...estiloSelect, }}>     
                    <Typography style={{color:opcion===1 ? "white": "", fontWeight:700}} >Orden de Trabajo</Typography>            
                </CardContent>
            </Card>
        </Typography>
        <Typography  title={'Tablero de Paros y Fallas.'}>
            <Card onClick={()=>setOpcion(2)} style={{marginRight:"1rem"}}>
            <CardContent style={{padding:0, paddingTop:".5rem", paddingBottom:".5rem", paddingRight:".5rem",  paddingLeft:".5rem",
                ...estiloSelect2
                }}>
                <Typography style={{color:opcion===2 ? "white": "", fontWeight:700}} > Paros y Fallas</Typography>
            </CardContent>        
            </Card>
        </Typography>
          <Typography  title={'Tablero de Plan Anual.'}>
            <Card onClick={()=>setOpcion(3)}  >
                <CardContent  style={{padding:0, paddingTop:".5rem", paddingBottom:".5rem", paddingRight:".5rem",  paddingLeft:".5rem",   
                    ...estiloSelect3, }}>     
                    <Typography style={{color:opcion===3 ? "white": "", fontWeight:700}} >Plan Mensual</Typography>            
                </CardContent>
            </Card>
        </Typography>
    </Box>
    )
}

const principal=(auxRuta)=>{
    //console.log(auxTotal);
        const token30 = localStorage.getItem('token30');
        const token20 = localStorage.getItem('token20');
        const auxtkn = token20.substring(token20.length-24,token20.length-1)
        //console.log(auxtkn);
        
    return(
    <Box display="flex"  style={{width:"82vw",height:"80vh"}} >            
        <iframe src={`https://lineaverde-board-qa.daduva.mx/${auxRuta}/${token30}/1`}   frameborder="0"
            style={{width:"100%", height:"100%"}}/>                             
    </Box>      
    )
}   
    return (
    <div>
        {cardOpcion()}
        {ruta.length!==0 ? principal(ruta):null}            
    </div>
    )
}

export default Tablero
